import React from 'react';

import * as styles from '../../../PrimaryNavigation.module.scss';
import {
  MenuHeader,
  MenuItem,
  MenuSection,
  MenuSeparator,
  MenuCollection,
  Text,
} from 'components/core';
import { Organization } from 'components/shared/PrimaryNavigation/PrimaryNavigation';
import { Inline } from 'components/layout';
import { PartyAvatar } from 'components/shared/PartyAvatar';

type Props = {
  organizations: Organization[];
  className?: string;
};

const OrganizationSection = ({ organizations }: Props) => {
  if (!organizations?.length) {
    return null;
  }

  return (
    <MenuSection>
      <MenuHeader>
        <Text
          size="xs"
          variant="weak"
          className={styles.PrimaryNavigation_paddingMenu}
        >
          Organizations
        </Text>
      </MenuHeader>
      <MenuCollection items={organizations}>
        {(item) => {
          if (item.isAdmin) {
            return (
              <MenuItem
                key={item.id}
                href={`/organizations/${item.id}/overview`}
              >
                <Inline alignX="left" spacing={2}>
                  <PartyAvatar
                    name={item.name}
                    size="xs"
                    variant="organization"
                    aria-hidden
                  />
                  {item.name}
                </Inline>
              </MenuItem>
            );
          }

          return (
            <MenuItem key={item.id}>
              <Inline alignX="left" spacing={2}>
                <PartyAvatar
                  name={item.name}
                  size="xs"
                  variant="organization"
                  aria-hidden
                />
                {item.name}
              </Inline>
            </MenuItem>
          );
        }}
      </MenuCollection>
      <MenuSeparator />
    </MenuSection>
  );
};

export default OrganizationSection;
